(function (module) {
    'use strict';

    const reorder = (arr, order) =>
        _.sortBy(arr, (file) =>
            order.includes(file.id) ? order.indexOf(file.id) : arr.length,
        );

    function ModalCtrl($scope, $mdDialog, $state) {
        // Track selected files without modifying them
        this.selectedFiles = this.selectedFilesIds.reduce((acc, i) => {
            acc[i] = true;
            return acc;
        }, {});

        this.cancel = () => {
            $mdDialog.hide();
        };

        this.confirm = () => {
            const newSelection = this.files.filter(file => this.selectedFiles[file.id]);
            const ordered = reorder(newSelection, this.selectedFilesIds);
            this.selectFiles(ordered);
            this.cancel();
        };

        this.isChecked = ({ id }) => this.selectedFiles[id];
        this.toggleFileSelected = ({ id }) => this.selectedFiles[id] = !this.selectedFiles[id];

        this.selectAll = () => {
            this.files.forEach(({ id }) => {
                this.selectedFiles[id] = true;
            });
        };

        this.unselectAll = () => {
            this.files.forEach(({ id }) => {
                this.selectedFiles[id] = false;
            });
        };

        this.goToUploadFiles = () => {
            $state.go('root.files.add');
            this.cancel();
        };
    }

    module.config(['formlyConfigProvider', (formlyConfigProvider, $mdDialog, Store) => {
        formlyConfigProvider.setType({
            name: 'formlyPicker',
            template: `
                <div class="formly-picker">
                    <md-content ng-if="loading">
                        <div class="formly-picker__loading">
                            <h2 translate="FILES.WHEN_LOADING"></h2>
                        </div>
                    </md-content>
                    <p class="playlist-header" ng-if="selectedFiles.length && !loading">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span>The slider will loop infinitely</span>
                    </p>

                    <p class="playlist-header" ng-if="selectedFiles.length && !loading">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span> Drag and drop files to change order</span>
                    </p>
                    <md-content dnd-list="selectedFiles" class="files-wrapper playlist" flex="100" ng-if="selectedFiles.length && !loading">
                        <div dnd-disable-if="model.orderBy && model.orderBy !== 'none'" dnd-draggable="file" dnd-moved="movedFile($index)" dnd-dragend="droppedFile($index)" class="app-tile file" ng-repeat="file in selectedFiles">
                             <span class="number">{{$index +1}}</span>
                             <file-tile class="app-tile file"
                                   title-name="file.fileName"
                                   background-image="file.thumbnail"
                                   resolution="file.width + '  x  ' + file.height"
                                   codec-name="file.codecName"
                                   codec-tag-string="file.codecTagString"
                                   frame-rate="file.rFrameRate"
                                   file-size="file.contentLength"
                                   delete-click="deleteItem($index)"
                                   set-display-time="setDisplayTime(fileId, displayTime)"
                                   duration="file.duration"
                                   show-display-time="{true}"
                                   display-time="file.displayTime"
                                   file-id="file.id"
                                   file-type="file.contentType"
                                   file-created-at="file.createdAt"
                                   file-type-header="file.fileTypeHeader"
                                   >
                        </file-tile>
                        </div>

                        <md-button ng-show="selectedFiles.length" class="formly-picker-btn delete-btn" ng-click="deleteAll()">
                            <i class="fa fa-trash-o" class="md-warn"></i>
                             <md-tooltip class="button-tooltip">Remove all</md-tooltip>
                        </md-button>

                        <div class="dndPlaceholder">
                            <i class="fa fa-hand-o-down drop-here" aria-hidden="true"></i>
                            <span>Drop file</span>
                        </div>

                    </md-content>
                    <md-button ng-if="!loading" class="custom-long-btn formly-picker-btn md-normal" ng-click="pickFiles()">
                        <i class="fa fa-hand-pointer-o active "></i>
                        <span ng-show="!files.length">Pick your files</span>
                        <span ng-show="files.length">Pick more files</span>
                    </md-button>
                </div>
            `,

            controller: ['$scope', '$mdDialog', 'Store', '$http', 'envService', '$timeout', ($scope, $mdDialog, Store, $http, envService, $timeout) => {

                $scope.formOptions = { formState: $scope.formState };

                $scope.getFiles = () => {
                    const account = Store.getCurrentAccount();
                    const subAccountId = Store.getCurrentSubAccountId();

                    const params = {};
                    if (subAccountId) {
                        _.set(params, 'subAccountId', subAccountId);
                    }
                    const request = {
                        method: 'GET',
                        url: `${envService.read('SLS_URI')}/files/list/${account.id}`,
                        params,
                    };

                    return $http(request)
                        .then(({ data }) => {
                            const FILES = data.map(file => {
                                file.fileTypeHeader = '';
                                if (file.contentType.startsWith('video')) {
                                    file.fileTypeHeader = 'video';
                                }
                                if (file.contentType.startsWith('image')) {
                                    file.fileTypeHeader = 'image';
                                }
                                return file;
                            });
                            Store.setMultiModelData('files', FILES);
                        })
                        .catch((error) => {
                            console.error(error);
                            Raven.captureException(error);
                        });

                };

                $timeout(() => {
                    $scope.getFiles().then(() => {
                        $scope.allFiles = Store.getFiles();  // All available files
                        $scope.model.files = $scope.model.files || []; // Array of selected ids
                        $scope.selectedFiles = getSelectedFilesFromAllFiles();

                        console.log('$scope.model.files', $scope.model.files);
                    });
                });

                $scope.$watch('$scope.model.files', () => {
                    console.log('$scope.model.files', $scope.model.files);
                });

                $scope.onLoad = () => {

                };

                $scope.deleteAll = () => {
                    $scope.selectedFiles = [];
                    $scope.form.$setDirty();
                };

                $scope.deleteItem = (index) => {
                    $scope.selectedFiles.splice(index, 1);
                    $scope.form.$setDirty();
                };

                $scope.setDisplayTime = (fileId, displayTime) => {
                    $scope.selectedFiles.forEach(selectedFile => {
                        if (selectedFile.id === fileId) selectedFile.displayTime = displayTime;
                    });
                    updateModel($scope.selectedFiles);
                    $scope.form.$setDirty();
                };

                $scope.droppedFile = (index) => {
                    // $scope.form.$setDirty();
                };

                $scope.movedFile = (index) => {
                    $scope.selectedFiles.splice(index, 1);
                    // $scope.form.$setDirty();
                };

                $scope.select = function (files) {
                    const newFiles = _.map(files, (file) => {
                        const displayTime = _.get(_.find($scope.selectedFiles, { id: file.id }), 'displayTime', null);
                        return (displayTime) ?
                            {
                                ...file,
                                displayTime,
                            }
                            : {
                                ...file,
                                displayTime: null,
                            };
                    });

                    const orderedNewFiles = orderFiles($scope.model.orderBy, newFiles);
                    $scope.selectedFiles = orderedNewFiles || [];
                    $scope.form.$setDirty();
                };

                const updateModel = _.debounce(newValue => {
                    const files = newValue.map(file => {
                        return { id: file.id, displayTime: file.displayTime };
                    });

                    if (!_.isEqual(files, $scope.model.files)) {
                        $timeout(() => {
                            $scope.$apply(() => {
                                $scope.form.$setDirty();
                                $scope.model.files = [...files];
                            });
                        });
                    }
                }, 50);

                const getSelectedFilesFromAllFiles = () => {
                    const isArrayOfObjects = _.get($scope, 'model.files[0].id');
                    if (isArrayOfObjects) {
                        return $scope.model.files
                            .map(({ id, displayTime }) => {
                                const file = $scope.allFiles.find(file => file.id === id);
                                return { ...file, displayTime };
                            })
                            .filter((file) => !!file.id);
                    }

                    return $scope.model.files
                        .map((id) => {
                            const file = $scope.allFiles.find(file => file.id === id);
                            return { ...file, displayTime: null };
                        })
                        .filter(file => !!file);
                };

                $scope.$watch('$scope.allFiles', () => {
                    // if no files loaded yet, bail
                    if (!$scope.allFiles) return;
                    $scope.selectedFiles = getSelectedFilesFromAllFiles();
                });

                const orderByName = (files) => {
                    return files.slice().sort((a, b) => a.fileName.localeCompare(b.fileName, undefined, { numeric: true }));
                };

                const orderByUpload = (files) => {
                    return _.sortBy(files, (file) => {
                        return file.createdAt;
                    });
                };

                const orderFiles = (orderBy, filesToOrder) => {
                    if (orderBy === 'none') return filesToOrder;
                    if (!orderBy) return filesToOrder;

                    if (!filesToOrder) return [];
                    if (!$scope.selectedFiles) return [];

                    let orderedFiles;
                    if (orderBy === 'name-a-z') {
                        orderedFiles = orderByName(filesToOrder);
                    }

                    if (orderBy === 'name-z-a') {
                        orderedFiles = _.reverse(orderByName(filesToOrder));
                    }

                    if (orderBy === 'upload-newest-first') {
                        orderedFiles = orderByUpload(filesToOrder);
                    }

                    if (orderBy === 'upload-latest-first') {
                        orderedFiles = _.reverse(orderByUpload(filesToOrder));
                    }

                    if (!orderedFiles) return filesToOrder;
                    return orderedFiles;
                };

                $scope.$watch('model.orderBy', function (orderBy) {
                    const orderedFiles = orderFiles(orderBy, [...($scope.selectedFiles || [])]);
                    if (orderedFiles && orderedFiles.length) {
                        $scope.selectedFiles = [...orderedFiles];
                    }
                }, true);

                $scope.$watchCollection('selectedFiles', (newValue) => {
                    if (!newValue) return;

                    updateModel(newValue);

                    if (!$scope.$$phase) {
                        $timeout(() => {
                            $scope.$apply();
                        });
                    }
                });

                $scope.pickFiles = () => {
                    $mdDialog.show({
                        locals: {
                            title: 'Select files from the list below',
                            cancelText: 'Cancel',
                            files: $scope.allFiles,
                            selectedFilesIds: $scope.model.files.map(({ id }) => id),
                            selectFiles: $scope.select,
                        },
                        controller: ModalCtrl,
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/file-picker-dialog/file-picker-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });
                };
            }],
        });
    }]);
})(angular.module('rocket.components'));
